import React, {useEffect} from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useStateContext } from './contexts/ContextProvider';
import './App.css';

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';


const App = () => {
  const {currentMode, setCurrentColor, setCurrentMode, activeMenu, currentColor, themeSettings, setThemeSettings, isAuthenticated, setIsAuthenticated } = useStateContext();

  return (

    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicios" element={<Services />} />
          <Route path="/sobre-nosotros" element={<About />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>

  );
};

export default App;